module.exports = __webpack_public_path__ + "img/emo_47.39f6dcd9.png";